import styled, { css } from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
var COLORS = {
  accent1: {
    color: 'accent1',
    backgroundColor: 'accent1LL'
  },
  accent2: {
    color: 'accent2',
    backgroundColor: 'accent2LL'
  },
  accent3: {
    color: 'accent3',
    backgroundColor: 'accent3LL'
  },
  positiveD: {
    color: 'positiveLL',
    backgroundColor: 'positiveD'
  },
  positive: {
    color: 'positiveLL',
    backgroundColor: 'positive'
  },
  positiveLL: {
    color: 'positiveD',
    backgroundColor: 'positiveLL'
  },
  warn: {
    color: 'warnLL',
    backgroundColor: 'warnDD'
  },
  warnL: {
    color: 'warnDD',
    backgroundColor: 'warnL'
  },
  warnLL: {
    color: 'warnDD',
    backgroundColor: 'warnLL'
  },
  negativeD: {
    color: 'negativeLL',
    backgroundColor: 'negativeD'
  },
  negative: {
    color: 'negativeLL',
    backgroundColor: 'negative'
  },
  negativeL: {
    color: 'negativeDD',
    backgroundColor: 'negativeL'
  },
  negativeLL: {
    color: 'negativeD',
    backgroundColor: 'negativeLL'
  },
  primary: {
    color: 'primaryLL',
    backgroundColor: 'primary'
  },
  secondary: {
    color: 'secondaryLL',
    backgroundColor: 'secondary'
  },
  secondary2: {
    color: 'secondary',
    backgroundColor: 'secondaryLL'
  },
  terciary: {
    color: 'terciaryLL',
    backgroundColor: 'terciary'
  }
};
export var TagBlock = styled.span.withConfig({
  displayName: "TagBlock",
  componentId: "sc-nlyvlg-0"
})(["display:inline-block;position:relative;padding:1px 9px 2px;border-radius:4px;margin:", ";cursor:pointer;background:", ";background:", ";", ";font-variant:small-caps;color:", ";color:", ";text-transform:lowercase;transition:all 0.15 ease;svg{cursor:pointer;}", ""], function (_ref) {
  var _ref$withMargin = _ref.withMargin,
    withMargin = _ref$withMargin === void 0 ? false : _ref$withMargin;
  return "".concat(withMargin ? '3px' : '0');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.accent1LL;
}, function (_ref3) {
  var theme = _ref3.theme,
    color = _ref3.color;
  return theme.colors[COLORS[color].backgroundColor];
}, getFont(0, 'compact'), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.accent1;
}, function (_ref5) {
  var theme = _ref5.theme,
    color = _ref5.color;
  return theme.colors[COLORS[color].color];
}, function (_ref6) {
  var small = _ref6.small;
  return small && css(["padding:1px 5px 2px;margin:", ";", ";"], function (_ref7) {
    var _ref7$withMargin = _ref7.withMargin,
      withMargin = _ref7$withMargin === void 0 ? true : _ref7$withMargin;
    return "".concat(withMargin ? '2px' : '0');
  }, getFont(-1, 'compact'));
});